// extracted by mini-css-extract-plugin
export default {"heartparent":"Heart_heartparent__VMlIb"};